import React from "react";

import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

import Box from "@mui/material/Box";
import AboutUs2ndpic from "../../images/AboutUs@ndpic.png";

const PGAboutUs2 = () => {
  return (
    <div className="QL__Sec__PGAboutUs2">
      <Container>
        {" "}
        <Grid container spacing={8}>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: { xs: "none", md: "flex" } }}>
              <img src={AboutUs2ndpic} alt="image" />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <h1 className="HeadingAll">Our Mission</h1>
            <p>
              Our mission is to make LearnQuranQuick a one-stop solution for
              people that are looking to enrich their or their closed one’s
              Quran teachings. LearnQuranQuick is an all-in-one platform where
              people can enhance their Quran learning and reading skills with
              the help of the finest Quran tutors in Pakistan.
            </p>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ display: { xs: "flex", md: "none" } }}>
              <img src={AboutUs2ndpic} alt="reading image" />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};
export default PGAboutUs2;
